import { apiClient, ApiClientResponse } from '../services/api-client';
import { LoginFormValues, RegistrationFormValues, UserProfile, ProfileFormValues } from '../models/User';

export default {
  logout: (): Promise<ApiClientResponse<UserProfile>> => apiClient.post(`/users/logout`),
  login: (values: LoginFormValues): Promise<ApiClientResponse<UserProfile>> => apiClient.post(`/users/login`, values),
  profile: (): Promise<ApiClientResponse<UserProfile>> => apiClient.get('/users/profile'),
  updateProfile: (values: Partial<UserProfile>): Promise<ApiClientResponse<UserProfile>> =>
    apiClient.post(`/users/profile`, values),
  register: (auth: RegistrationFormValues, profile: ProfileFormValues): Promise<ApiClientResponse<UserProfile>> =>
    apiClient.post(`/users/registration`, {
      ...auth,
      ...profile,
      meta: {
        registration: {
          channel: 'eshop',
          locale: 'cz',
        },
      },
    }),
  activateRegistration: (token: string): Promise<ApiClientResponse<void>> =>
    apiClient.get('/users/activation', {
      params: {
        token,
      },
    }),
  forgotPassword: (email: string): Promise<ApiClientResponse<void>> =>
    apiClient.post('/users/recovery', {
      email,
    }),
  changePassword: (token: string, password: string): Promise<ApiClientResponse<void>> =>
    apiClient.post('/users/recovery', {
      token,
      password,
    }),
  updatePassword: (password: string): Promise<ApiClientResponse<void>> =>
    apiClient.post('/users/profile', {
      password,
    }),
  find: (id: string): Promise<ApiClientResponse<UserProfile>> =>
    apiClient.get('/users/find', {
      params: {
        id,
      },
    }),
};
